<div tp="Need to Save changes" [tpIsEnabled]="needSave === true">
  <button
    data-cy="fileOptionsMenuButton"
    class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
    [ngClass]="{
      'cursor-default': needSave === true,
      'hover:bg-m200': needSave === false
    }"
    [disabled]="needSave === true"
    #t1="tippy"
    [tp]="templateFileOptions"
    [tpHideOnEscape]="true"
    tpVariation="menu"
    className="my-menu"
    (click)="clickMenu($event)"
  >
    <m-dots-vertical-icon></m-dots-vertical-icon>
  </button>
</div>

<ng-template #templateFileOptions>
  <div class="border-s4 bg-m0 w-48 rounded-md border-2 shadow-xl">
    <button
      data-cy="fileOptionsDeleteFileButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); deleteFile(node, $event)"
      >Delete File</button
    >

    <button
      data-cy="fileOptionsRenameFileButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); renameFile(node, $event)"
      >Rename File</button
    >
  </div>
</ng-template>

<div *ngIf="nav$ | async"></div>
<div *ngIf="needSave$ | async"></div>
